import React from 'react';
import type {NativeStackScreenProps} from '@react-navigation/native-stack';

import {useAuthStore} from '@/entities/session/auth-store';
import type {PeopleStackParamList} from '@/app/routes';
import {PersonCard} from '@/features/view-people/ui/PersonCard';
import {Page} from '@/shared/ui/page';

/** «Люди» → карточка человека, только на чтение. */
type Props = NativeStackScreenProps<PeopleStackParamList, 'Person'>;

export function PersonScreen({route}: Props) {
  const companyId = useAuthStore(s => s.activeContext?.companyId);
  const {recordId, name} = route.params;

  return (
    // Имя приезжает параметром маршрута, поэтому заголовок называет запись раньше,
    // чем загрузится карточка под ним — ровно для этого `name` и едет в параметрах.
    <Page scroll width="form" title={name} testID="person-screen">
      {companyId ? <PersonCard companyId={companyId} recordId={recordId} /> : null}
    </Page>
  );
}
